export const PO_DATE_CREATED = 'created'
export const PO_DATE_UPDATED = 'updated'
export const PO_DATE_SENT = 'sent'
export const PO_DATE_GR_RECEIVED = 'gr_received'
export const PO_DATE_GR_CREATED = 'gr_created'
export const PO_DATE_GR_UPDATED = 'gr_updated'
export const PO_DATE_ESTIMATED_DELIVERY = 'estimated_delivery'

export const PO_DATE_CREATED_OPTION = {
  value: PO_DATE_CREATED,
  display: 'Created Date',
}

export const PO_DATE_UPDATED_OPTION = {
  value: PO_DATE_UPDATED,
  display: 'Updated Date',
}

export const PO_DATE_SENT_OPTION = {
  value: PO_DATE_SENT,
  display: 'Sent Date',
}

export const PO_DATE_GR_CREATED_OPTION = {
  value: PO_DATE_GR_CREATED,
  display: 'Goods Receipt Created Date',
}

export const PO_DATE_GR_UPDATED_OPTION = {
  value: PO_DATE_GR_UPDATED,
  display: 'Goods Receipt Updated Date',
}

export const PO_DATE_GR_RECEIVED_OPTION = {
  value: PO_DATE_GR_RECEIVED,
  display: 'Goods Receipt Received Date',
}

export const PO_DATE_ESTIMATED_DELIVERY_OPTION = {
  value: PO_DATE_ESTIMATED_DELIVERY,
  display: 'Estimated Delivery Date',
}

export const PO_DEFAULT_DATE_RANGE_TYPE = PO_DATE_SENT

export const PO_DATE_RANGE_FILTERS = [
  PO_DATE_CREATED,
  PO_DATE_UPDATED,
  PO_DATE_SENT,
  PO_DATE_GR_CREATED,
  PO_DATE_GR_UPDATED,
  PO_DATE_GR_RECEIVED,
  PO_DATE_ESTIMATED_DELIVERY,
]

export const PO_DATE_RANGE_FILTER_OPTIONS = [
  PO_DATE_CREATED_OPTION,
  PO_DATE_UPDATED_OPTION,
  PO_DATE_SENT_OPTION,
  PO_DATE_GR_CREATED_OPTION,
  PO_DATE_GR_UPDATED_OPTION,
  PO_DATE_GR_RECEIVED_OPTION,
  PO_DATE_ESTIMATED_DELIVERY_OPTION,
]
